import { FileType } from 'utils/file-uploader';
import { Sort } from './interface';

export const API = {
  GET_FETCH_MEDIA: {
    path: '/expert-content/sort-search',
    method: 'GET',
  },
  GET_REMAINING_STROAGE: {
    path: '/expert-content/remaining-storage',
    method: 'GET',
  },
  POST_UPLOAD_MEDIA: {
    path: '/expert-content/create',
    method: 'POST',
  },
  DELETE_DELETE_MEDIA: {
    path: '/expert-content/expert-delete',
    method: 'DELETE',
  },
  POST_UPDATE_MEDIA: {
    path: '/expert-content/update',
    method: 'POST',
  },
  POST_VIDEO_TRIM: {
    path: '/expert-content/trim-video',
    method: 'POST',
  },
};

export enum MediaSort {
  AZ = 'a-z',
  ZA = 'z-a',
  NAME = 'name',
  DATE_ADDED = 'date-added',
  MODIFIED = 'modified',
  PURCHASED = 'purchased',
  UPLOADED = 'uploaded',
}

export const sortByFilters = [
  {
    text: 'A to Z',
    value: Sort.AZ,
  },
  {
    text: 'Z to A',
    value: Sort.ZA,
  },
  {
    text: 'Uploaded',
    value: Sort.UPLOADED,
  },
] as const;

export const typeFilters = [
  {
    text: 'Video',
    value: FileType.VIDEO,
  },
  {
    text: 'Audio',
    value: FileType.AUDIO,
  },
  {
    text: 'Image',
    value: FileType.IMAGE,
  },
  {
    text: 'Document',
    value: FileType.DOCUMENT,
  },
  {
    text: 'Folder',
    value: FileType.FOLDER,
  },
] as const;
